export enum ApiQueries {
  COSTS = 'COSTS',
  PATIENT = 'PATIENT',
  DOCTORS = 'DOCTORS',
  PATIENT_RESULT = 'PATIENT_RESULT',
}
